import { defineComponent, computed, createBlock, createElementBlock, openBlock, resolveDynamicComponent, normalizeClass } from "vue";
import { getLocalIcon } from "./localIcons.js";
const _hoisted_1 = ["alt", "src"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProjectIcon",
  props: {
    src: {},
    title: {},
    mask: { type: Boolean }
  },
  setup(__props) {
    const props = __props;
    const data = computed(() => getLocalIcon(props.src));
    return (_ctx, _cache) => {
      return data.value ? (openBlock(), createBlock(resolveDynamicComponent(data.value), { key: 0 })) : (openBlock(), createElementBlock("img", {
        key: 1,
        alt: _ctx.title,
        class: normalizeClass(["project-icon-image", { "mask-image": _ctx.mask }]),
        src: _ctx.src
      }, null, 10, _hoisted_1));
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProjectIcon.vue2.js.map
